import React, { useState, useEffect } from "react";  
import styles from "./ControlPanel.module.css";  
  
const ControlPanel = ({showMessages, callStatus, finishCallHandler}) => {  
  const [waveHeights, setWaveHeights] = useState(Array(10).fill(6)); // 10 dots  
  
  
  return (  
    <div className={styles.controlPanel} style={{display: (callStatus !== "ready")?"none":"flex"}}>  
      {/* Chat Button */}  
      {/* <div className={`${styles.controlIconWrapper} ${styles.chatIconWrapper}`} onClick={showMessages}>  
        <span className={styles.controlIcon + ` material-symbols-outlined`}>chat_bubble_outline</span>
      </div>   */}
  
      {/* Dots Section (Wave Movement) */}  
      <div className={styles.waveSection}>  
        {waveHeights.map((height, i) => (  
          <div  
            key={i}  
            className={`${styles.dot} wave-user`}  
            style={{ height: `${height}px` }}  
          ></div>  
        ))}  
      </div> 
  
      {/* Buttons Section */}  
      <div className={styles.buttonsSection}>  
        {/* Microphone Button */}  
        <div  
          className={`${styles.controlIconWrapper} ${styles.microphoneIconWrapper}`}  
          id="btn-toggle-mic"  
        >  
          <span className={`${styles.controlIcon} material-symbols-outlined`}>  
            mic  
          </span>  
        </div>  
  
        {/* Hang-Up Button */}  
        <div  
          className={`${styles.controlIconWrapper} ${styles.phoneIconWrapper}`}  
          onClick={finishCallHandler}  
        >  
          <span  
            className={`${styles.controlIcon} ${styles.hangupIcon} material-symbols-outlined`}  
          >  
            call_end  
          </span>  
        </div>  
      </div> 
    </div>  
  );  
};  
  
export default ControlPanel;  